import React from "react";
import { Divider } from "@mui/material";

export const GenericDivider = ({ color = '#F4F6F8', margin = '15px 0', children }) => {
  return (
    <Divider sx={{ borderColor: color, margin: margin, "&::before, &::after": { borderColor: color } }} >
      {children}
    </Divider>
  );
};